import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';

import {Button, Col, Form, Modal, Row, Table, Tabs, Tab, Card} from "react-bootstrap";
import axios from "axios";
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions, TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";
import {CaseView} from "./CaseView";
import {CaseDetailsView} from "./CaseDetailsView";
import {AddVisitView} from "./subCategories/visit/AddVisitView";
import {padNumber} from "../utils";
import {hasPermissions, IPD_CASE_MGT, OPHTHALMOLOGY} from "../permissions";
import {useCookies} from "react-cookie";


export const IPDView = (props: { cookieEntityQr: string, caseNumber: string, uhid: string }) => {

    const [loading, setLoading] = useState(true)
    const [cases, setCases] = useState<Array<any>>([])
    const [selectedCase, setSelectedCase] = useState(null)
    const [ipdEnabled, setIpdEnabled] = useState(false)
    const [doctors, setDoctors] = useState<Array<any>>([])
    const [filterStatus, setFilterStatus] = useState("ACTIVE")
    const [cookie] = useCookies(['qme']);


    function loadEntityData() {
        axios.get('/api/backend/entity/profile/' + props.cookieEntityQr)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setDoctors(resp.data.clientProfileEntities)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    useEffect(() => {
        if (props.cookieEntityQr) {
            loadEntityData()
            axios.get('/api/backend/entity/profile/' + props.cookieEntityQr)
                .then(resp => {
                    setIpdEnabled(resp.data.ipdEnabled)
                    if (resp.data.ipdEnabled) {
                        if (props.caseNumber) {
                            fetchCase()
                        } else {
                            fetchCases()
                        }
                    }
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                }).finally(() => {
                setLoading(false)
            })
        }
    }, [props.cookieEntityQr, props.caseNumber])

    useEffect(() => {
        fetchCases()
    }, [filterStatus])

    useEffect(() => {
        if (props.uhid) {
            handleShowAddModal()
        }
    }, [props.uhid])


    function fetchCases() {
        axios.get('/api/backend/ipd/case/fetch/all/' + props.cookieEntityQr + "?status=" + filterStatus)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setCases(resp.data)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    function fetchCase() {
        axios.get('/api/backend/ipd/case/fetch/' + props.cookieEntityQr + '/' + props.caseNumber)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setSelectedCase(resp.data)
                fetchCases()
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                fetchCases()
            })
    }

    const [showAddModal, setShowAddModal] = useState(false);
    const handlePostAddModal = () => {
        fetchCases()
        handleCloseAddModal();
    }
    const handleCloseAddModal = () => setShowAddModal(false);
    const handleShowAddModal = () => {
        setShowAddModal(true)
    }

    function getModalForAddCase() {
        return <Modal
            show={showAddModal}
            onHide={handleCloseAddModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <CaseDetailsView cookieEntityQr={props.cookieEntityQr} caseNumber={null} doctors={doctors}
                                 postAction={handlePostAddModal} createForUhid={props.uhid}/>
            </Modal.Body>
        </Modal>;
    }

    const [showAddVisitModal, setShowAddVisitModal] = useState(false);
    const [selectedCaseIdForNotes, setSelectedCaseIdForNotes] = useState();
    const handlePostAddVisitModal = () => {
        handleCloseAddVisitModal();
    }
    const handleCloseAddVisitModal = () => setShowAddVisitModal(false);
    const handleShowAddVisitModal = (selectedCaseIdForNotes) => {
        setSelectedCaseIdForNotes(selectedCaseIdForNotes)
        setShowAddVisitModal(true)
    }

    function getModalForAddVisitCase() {
        return <Modal
            show={showAddVisitModal}
            onHide={handleCloseAddVisitModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <AddVisitView cookieEntityQr={props.cookieEntityQr} caseId={selectedCaseIdForNotes}
                              postAction={handlePostAddVisitModal} doctors={doctors} visitData={null}/>
            </Modal.Body>
        </Modal>;
    }

    const [showDeleteCaseModal, setShowDeleteCaseModal] = useState(false);
    const [selectedCaseIdForDelete, setSelectedCaseIdForDelete] = useState();
    const [deleteError, setDeleteError] = useState(null);
    const handleCloseDeleteCaseModal = () => setShowDeleteCaseModal(false);
    const handleShowDeleteCaseModal = (selectedCaseIdForDelete) => {
        setDeleteError(null)
        setSelectedCaseIdForDelete(selectedCaseIdForDelete)
        setShowDeleteCaseModal(true)
    }

    const handleDeleteCase = () => {
        axios.delete('/api/backend/ipd/case/delete/' + selectedCaseIdForDelete)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setShowDeleteCaseModal(false)
                fetchCases()
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                setDeleteError("* Something went wrong! try again later.")
            })
    }

    function getModalForDeleteCase() {
        return <Modal
            show={showDeleteCaseModal}
            onHide={handleCloseDeleteCaseModal}
            backdrop="static"
        >
            <Modal.Body>
                <div className="fs-5 my-3 text-danger">
                    Please note that this case will not be accessible anymore.
                    The billed items will added back to the stock.
                    Please confirm to proceed removing the case.
                </div>
                {deleteError && <div className="fs-7 text-danger my-3">{deleteError}</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="btn btn-secondary" onClick={handleCloseDeleteCaseModal}>
                    Cancel
                </Button>
                <Button variant="btn btn-primary text-white" onClick={handleDeleteCase}>Confirm</Button>
            </Modal.Footer>
        </Modal>;
    }

    const CASES_HEADERS: TableColumnType<any>[] = [
            {
                prop: "sno",
                title: "#",
                isFilterable: false,
                isSortable: true
            },
            {
                prop: "caseId",
                title: "Case #",
                isFilterable: true,
                isSortable: true,
                cell: (row) => (
                    <><a href="#/" className="text-decoration-none text-primary"
                         onClick={e => setSelectedCase(row)}><img
                        height="14rem" width="14rem" src="/external-link.png" alt="external-link-icon"
                        className="align-self-center"/>&nbsp;&nbsp;{row.caseId}</a></>
                )
            },
            {
                prop: "ipdId",
                title: "IPD #.",
                isFilterable: true,
                isSortable: true,
                cell: (row) => (
                    <>{padNumber(row.ipdId)}</>
                )
            },
            {
                prop: "extUhid",
                title: "Hospital UHID",
                isFilterable: true
            },
            {
                prop: "uhid",
                title: "UHID",
                isFilterable: true
            },
            {
                prop: "customerName",
                title: "Patient Name",
                isFilterable: true
            },
            {
                prop: "assignedDr",
                title: "Doctor In-charge",
                isFilterable: true
            },
            {
                prop: "bedName",
                title: "Bed",
                isSortable: true,
                isFilterable: true
            },
            {
                prop: "customerMobile",
                title: "Phone no",
                isFilterable: true
            },
            {
                prop: "status",
                title: "Status",
                isFilterable: true,
                isSortable: true,
                cell: (row) => (
                    <>
                        {row.status == "ACTIVE" && <div className="text-success">Active</div>}
                        {row.status == "SUMMARY_APPROVED" && <div className="text-danger">Discharge Approved</div>}
                        {row.status == "DISCHARGED" && <div className="text-danger">Discharged</div>}
                        {row.status == "BILL_PAID" && <div className="text-danger">Bill Paid</div>}
                        {row.status == "CLOSED" && <div className="text-danger">Closed</div>}
                    </>
                )
            },
            {
                prop: "actions",
                title: "Actions",
                cell: (row) => (
                    <>
                        {row.status == "ACTIVE" && <>
                            <a href="#/" className="fs-5"
                               onClick={e => handleShowAddVisitModal(row.id)}>📝</a>&nbsp;&nbsp;&nbsp;
                            {hasPermissions(cookie.qme, IPD_CASE_MGT) && <a href="#/" className="remove" onClick={e => handleShowDeleteCaseModal(row.id)}>X</a>}
                        </>
                        }
                    </>
                )
            },

        ]
    ;

    function getCasesTable() {
        return <div className="overflow-scroll"><DatatableWrapper
            body={cases}
            headers={CASES_HEADERS}
            paginationOptionsProps={{
                initialState: {
                    rowsPerPage: 30,
                    options: [30, 50, 100]
                }
            }}
        >
            <Row className="mb-4 p-2">
                <Col
                    xs={12}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Filter placeholder="Search by Case #, Name or Phone # ..."/>
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
                >
                    <PaginationOptions/>
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Pagination/>
                    <Button className="btn btn-warning text-white"
                            onClick={fetchCases}>
                        &#8634;
                    </Button>
                </Col>
            </Row>
            <Table>
                <TableHeader/>
                <TableBody/>
            </Table>
            <Row className="mt-4 p-2">
                <Col
                    xs={12}
                    sm={12}
                    lg={12}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Pagination/>
                </Col>
            </Row>
        </DatatableWrapper>
        </div>;
    }


    function getIPDDetails() {
        return <>
            {!loading && <>
                {ipdEnabled &&
                    <>
                        {!selectedCase && <>
                            <div className="row">
                                <div className="col">
                                    <div className="card p-2 shadow-sm">
                                        <div className="d-flex justify-content-between py-2 pr-2">
                                            <h4 className="text-primary pl-1">IPD Cases</h4>
                                            <div className="text-center"><Form.Select
                                                className="form-select form-select-sm bg-light text-primary"
                                                value={filterStatus}
                                                name="type"
                                                style={{maxWidth: 200}}
                                                onChange={e => setFilterStatus(e.target.value)}
                                            >
                                                <option value="ACTIVE">Active</option>
                                                <option value="DISCHARGED">Discharged</option>
                                                <option value="CLOSED">Closed</option>
                                            </Form.Select></div>
                                            {hasPermissions(cookie.qme, IPD_CASE_MGT) && <Button className="btn btn-warning btn-sm text-white float-right"
                                                    onClick={e => setShowAddModal(true)}
                                            >+ Add Case
                                            </Button>}
                                        </div>
                                        {getCasesTable()}
                                        {getModalForAddCase()}
                                        {getModalForAddVisitCase()}
                                        {getModalForDeleteCase()}
                                    </div>
                                </div>
                            </div>
                        </>}
                        {selectedCase &&
                            <CaseView cookieEntityQr={props.cookieEntityQr} case={selectedCase} doctors={doctors}
                                      clearCaseId={() => {
                                          setSelectedCase(null)
                                          fetchCases()
                                      }
                                      }/>
                        }
                    </>
                }
                {!ipdEnabled &&
                    <div className="fs-3 text-secondary text-center py-5">Licence not available for this
                        module.</div>
                }
            </>
            }

            {loading &&
                <div className="text-center py-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            }
        </>;
    }

    return (
        <>
            <div className="row mx-lg-5">
                <div className="col">
                    {getIPDDetails()}
                </div>
            </div>

        </>
    );
}
